// Theme: cassette
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'cassette',
  name: 'CASSETTE',
  tagline: 'CASSETTE',
  description: 'Fita cassete e anos 80 analogicos. Ambar quente.',
  category: 'retro-memory',
  tier: 'common',
  basePrice: 300,
  swatches: ['#1A1408', '#D4891F', '#2A2010', '#F0D8A8'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '2px',
      '--radius': '0px',
      '--shadow-card': 'none',
      '--shadow-card-active': 'inset 0 0 0 1px color-mix(in srgb, var(--primary) 20%, transparent)'
    },
    shellClasses: 'font-sans theme-cassette'
  },
  colorVars: {
    '--accent': '#D4891F',
    '--accent-foreground': '#1A1408',
    '--background': '#1A1408',
    '--border': '#7A5A20',
    '--card': '#2A2010',
    '--card-border-active': 'rgba(212, 137, 31, 0.04)',
    '--card-completed': '#332614',
    '--card-foreground': '#F0D8A8',
    '--card-glow': 'rgba(212, 137, 31, 0.04)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A1408',
    '--foreground': '#F0D8A8',
    '--hold-fill': '#D4891F',
    '--input': '#2A2010',
    '--modal-bg': '#1A1408',
    '--modal-border': '#7A5A20',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': 'none',
    '--muted': '#7A5A20',
    '--muted-foreground': '#D9B678',
    '--nav-active': '#D4891F',
    '--nav-bg': '#1A1408',
    '--popover': '#2A2010',
    '--popover-foreground': '#F0D8A8',
    '--primary': '#D4891F',
    '--primary-foreground': '#1A1408',
    '--ring': '#D4891F',
    '--secondary': '#7A5A20',
    '--secondary-foreground': '#F0D8A8',
    '--streak': '#D4891F',
    '--success': '#22c55e',
    '--success-foreground': '#1A1408',
    '--xp': '#D4891F',
    '--xp-bg': '#2A2010'
  },
  resolvedVars: {
    '--accent': '#D4891F',
    '--accent-foreground': '#1A1408',
    '--accent-foreground-hsl': '40 53% 7%',
    '--accent-foreground-oklch': 'from #1A1408 l c h',
    '--accent-hsl': '35 74% 48%',
    '--accent-oklch': 'from #D4891F l c h',
    '--background': '#1A1408',
    '--background-hsl': '40 53% 7%',
    '--background-oklch': 'from #1A1408 l c h',
    '--border': '#7A5A20',
    '--border-hsl': '39 58% 30%',
    '--border-oklch': 'from #7A5A20 l c h',
    '--border-w': '2px',
    '--card': '#2A2010',
    '--card-border-active': 'rgba(212, 137, 31, 0.04)',
    '--card-completed': '#332614',
    '--card-completed-hsl': '35 44% 14%',
    '--card-completed-oklch': 'from #332614 l c h',
    '--card-foreground': '#F0D8A8',
    '--card-foreground-hsl': '40 71% 80%',
    '--card-foreground-oklch': 'from #F0D8A8 l c h',
    '--card-glow': 'rgba(212, 137, 31, 0.04)',
    '--card-hsl': '37 45% 11%',
    '--card-oklch': 'from #2A2010 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A1408',
    '--destructive-foreground-hsl': '40 53% 7%',
    '--destructive-foreground-oklch': 'from #1A1408 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F0D8A8',
    '--foreground-hsl': '40 71% 80%',
    '--foreground-oklch': 'from #F0D8A8 l c h',
    '--hold-fill': '#D4891F',
    '--hold-fill-hsl': '35 74% 48%',
    '--hold-fill-oklch': 'from #D4891F l c h',
    '--input': '#2A2010',
    '--input-hsl': '37 45% 11%',
    '--input-oklch': 'from #2A2010 l c h',
    '--modal-bg': '#1A1408',
    '--modal-bg-hsl': '40 53% 7%',
    '--modal-bg-oklch': 'from #1A1408 l c h',
    '--modal-border': '#7A5A20',
    '--modal-border-hsl': '39 58% 30%',
    '--modal-border-oklch': 'from #7A5A20 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': 'none',
    '--muted': '#7A5A20',
    '--muted-foreground': '#D9B678',
    '--muted-foreground-hsl': '38 56% 66%',
    '--muted-foreground-oklch': 'from #D9B678 l c h',
    '--muted-hsl': '39 58% 30%',
    '--muted-oklch': 'from #7A5A20 l c h',
    '--nav-active': '#D4891F',
    '--nav-active-hsl': '35 74% 48%',
    '--nav-active-oklch': 'from #D4891F l c h',
    '--nav-bg': '#1A1408',
    '--nav-bg-hsl': '40 53% 7%',
    '--nav-bg-oklch': 'from #1A1408 l c h',
    '--popover': '#2A2010',
    '--popover-foreground': '#F0D8A8',
    '--popover-foreground-hsl': '40 71% 80%',
    '--popover-foreground-oklch': 'from #F0D8A8 l c h',
    '--popover-hsl': '37 45% 11%',
    '--popover-oklch': 'from #2A2010 l c h',
    '--primary': '#D4891F',
    '--primary-foreground': '#1A1408',
    '--primary-foreground-hsl': '40 53% 7%',
    '--primary-foreground-oklch': 'from #1A1408 l c h',
    '--primary-hsl': '35 74% 48%',
    '--primary-oklch': 'from #D4891F l c h',
    '--radius': '0px',
    '--ring': '#D4891F',
    '--ring-hsl': '35 74% 48%',
    '--ring-oklch': 'from #D4891F l c h',
    '--secondary': '#7A5A20',
    '--secondary-foreground': '#F0D8A8',
    '--secondary-foreground-hsl': '40 71% 80%',
    '--secondary-foreground-oklch': 'from #F0D8A8 l c h',
    '--secondary-hsl': '39 58% 30%',
    '--secondary-oklch': 'from #7A5A20 l c h',
    '--shadow-card': 'none',
    '--shadow-card-active': 'inset 0 0 0 1px color-mix(in srgb, var(--primary) 20%, transparent)',
    '--streak': '#D4891F',
    '--streak-hsl': '35 74% 48%',
    '--streak-oklch': 'from #D4891F l c h',
    '--success': '#22c55e',
    '--success-foreground': '#1A1408',
    '--success-foreground-hsl': '40 53% 7%',
    '--success-foreground-oklch': 'from #1A1408 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(35 74% 48% / 0.15)',
    '--xp': '#D4891F',
    '--xp-bg': '#2A2010',
    '--xp-bg-hsl': '37 45% 11%',
    '--xp-bg-oklch': 'from #2A2010 l c h',
    '--xp-hsl': '35 74% 48%',
    '--xp-oklch': 'from #D4891F l c h'
  }
}
